import { EnumValues } from "#customTypes/types"

export const USER_ROLES = {
  DEV: "DEV",
  SUPER: "SUPER",
  MANAGER: "MANAGER",
  FRONT_DESK: "FRONT_DESK",
  LEAD_TEACHER: "LEAD_TEACHER",
  TEACHER: "TEACHER",
  ASSISTANT: "ASSISTANT",
  DISABLED: "DISABLED",
} as const

export const USER_ACTIONS = {
  CREATE: "CREATE",
  READ: "READ",
  UPDATE: "UPDATE",
  DELETE: "DELETE",

  LOGIN: "LOGIN",
  MANAGER_LOGOUT: "MANAGER_LOGOUT",
  CREATE_SUPER_USER: "CREATE_SUPER_USER",
  DELETE_SUPER_USER: "DELETE_SUPER_USER",
  VIEW_CONTACT_INFO: "VIEW_CONTACT_INFO",
  ASSIGN_TEACHER_TO_EVAL: "ASSIGN_TEACHER_TO_EVAL",
  UPLOAD_DOCUMENT: "UPLOAD_DOCUMENT",
  HIDE_ARTWORK: "HIDE_ARTWORK",
} as const

export const USER_ROLE_COLORS = {
  [USER_ROLES.SUPER]: "red",
  [USER_ROLES.FRONT_DESK]: "blue",
  [USER_ROLES.LEAD_TEACHER]: "darkgreen",
  [USER_ROLES.TEACHER]: "green",
  [USER_ROLES.ASSISTANT]: "green",
  [USER_ROLES.DISABLED]: "gray",
}

// Similar to DOC_TYPES
export const RESOURCES = {
  USER: "USER",
  STUDENT: "STUDENT",
  CLASS: "CLASS",
  CURRICULUM_PLAN: "CURRICULUM_PLAN",
  PROJECT: "PROJECT",
  SEMESTER: "SEMESTER",
  MAKEUP: "MAKEUP",
  TRYOUT: "TRYOUT",
  TAG: "TAG",
  EVALUATION: "EVALUATION",
  FRONT_DESK_VIEW: "FRONT_DESK_VIEW",
  TEACHER_VIEW: "TEACHER_VIEW",
  SETTINGS: "SETTINGS",
  ID: "ID",
  TEST: "TEST",
  LOGIN: "LOGIN",
  HELP_REQUEST: "HELP_REQUEST",
  PROJECTS_PAGE: "PROJECTS_PAGE",
  CURRICULUM_PLANS_PAGE: "CURRICULUM_PLANS_PAGE",
  EVALUATIONS_PAGE: "EVALUATIONS_PAGE",
  USERS_PAGE: "USERS_PAGE",
  SETTINGS_PAGE: "SETTINGS_PAGE",
  FRONT_DESK_PAGE: "FRONT_DESK_PAGE",
  TEACHER_PAGE: "TEACHER_PAGE",
  STUDENTS_PAGE: "STUDENTS_PAGE",
  CLASSES_PAGE: "CLASSES_PAGE",
  MAKEUPS_PAGE: "MAKEUPS_PAGE",
  TRYOUTS_PAGE: "TRYOUTS_PAGE",
  TAGS_PAGE: "TAGS_PAGE",
  SEMESTERS_PAGE: "SEMESTERS_PAGE",
  TEST_PAGE: "TEST_PAGE",
  PROFILE_PAGE: "PROFILE_PAGE",
  AUTH_TEST_PAGE: "AUTH_TEST_PAGE",
  QUALITY_CHECK_PAGE: "QUALITY_CHECK_PAGE",
  STANDOUT_REVIEW_PAGE: "STANDOUT_REVIEW_PAGE",
  STAFF_NOTE: "STAFF_NOTE",
} as const

export type UserRole = EnumValues<typeof USER_ROLES>
export type UserAction = EnumValues<typeof USER_ACTIONS>
export type Resource = EnumValues<typeof RESOURCES>
